export const isLastArrayItem = <T>(array: T[], index: number) => {
  return index === array.length - 1;
};
